<template>
  <div class="assessment-sub-type-report container-fluid">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <assessment-sub-type-report-tab @clickedTab="selectedTab"></assessment-sub-type-report-tab>
      <report-filter-bar @selectedGroupObj="setGroupCourseObj" @selectedCohortObj="setCohortObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag"></report-filter-bar>
      <hr width="97%" size="10px">
      <div class="row margin-Top-2Perc">
        <div class="col-md-11 col-lg-11 width margin-left-0point4Perc">
          <sortable-list v-if="showAssessmentSubTypeReportList" v-bind:responseObj="getCurrSelectedTabReportRespArr" v-bind:sortableColumnName="sortColumnNames" v-bind:columnNameToShow="columnNameToShow" v-bind:linkColumnName="linkColumnNames" v-bind:selectedsubOption="10"></sortable-list>
        </div>
      </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>      
    </div>
    <loader></loader>
    <error-page v-if="isUserGroupAdmin"></error-page>       
  </div>  
</template>

<script>
import ReportFilterBar from '@/components/ReportFilterBar'
// import ReportGroupFilterBar from '@/components/ReportGroupFilterBar'
import list from '@/pages/SortableList'
import CopyrightElement from '@/components/CopyrightElement'
import { constants } from '@/utils/constants'
import { reportService } from '@/server-util/report-service'
import AlertBox from '@/components/AlertOverlay'
import csvHelper from '@/utils/csv-helper'
import ErrorPage from '@/pages/Error'
import Loader from '@/components/dashboard/Loader'
import { participantService } from '@/server-util/participant-service'
import AssessmentSubTypeReportTab from '../components/AssessmentSubTypeReportTab'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
export default {
  created: function () {
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      currentSelectedTab: 1,
      showAssessmentSubTypeReportList: false,
      selectedGroupCourseObj: null,
      selectedCohortObj: null,
      showExportButton: true,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      currSelectedTabReportRespArr: [],
      sortColumnNames: [],
      columnAlias: [],
      columnRespKey: [],
      columnRespKeyForExport: [],
      columnNameToShow: [],
      linkColumnNames: [],
      isExportBtnClicked: false,
      isViewBtnClicked: false
    }
  },
  components: {
    'assessment-sub-type-report-tab': AssessmentSubTypeReportTab,
    'report-filter-bar': ReportFilterBar,
    'Copyright-Element': CopyrightElement,
    'sortable-list': list,
    'alert-box': AlertBox,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    setGroupCourseObj (value) {
      // AK: When user selected particular group object then update it in parent file too
      this.selectedGroupCourseObj = value
    },
    setCohortObj (value) {
      // AK: When user selected particular cohort object then update it in parent file too
      this.selectedCohortObj = value
    },
    selectedTab (value) {
      if (this.currentSelectedTab !== parseInt(value)) {
        // AK: If user changed Tab then do not show list and reset view and export btn flag to false
        this.showAssessmentSubTypeReportList = false
      }
      this.currentSelectedTab = parseInt(value)
      if (!isEmpty(this.selectedGroupCourseObj) && !isEmpty(this.selectedCohortObj)) {
        this.updateViewBtnClickedFlag(true)
      }
    },
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    updateViewBtnClickedFlag (value) {
      this.isViewBtnClicked = value
      if (value) {
        switch (parseInt(this.currentSelectedTab)) {
          case 1:
            this.getAssessmentMCQReport()
            console.log('1 updateViewBtnClickedFlag')
            break
          case 2:
            this.getAssessmentReflectionReport()
            console.log('2 updateViewBtnClickedFlag')
            break
          case 3:
            break
          case 4:
            break
        }
      }
    },
    exportCSV (value) {
      this.isExportBtnClicked = value
      if (value) {
        switch (parseInt(this.currentSelectedTab)) {
          case 1:
            this.getAssessmentMCQReport()
            console.log('1 exportCSV')
            break
          case 2:
            this.getAssessmentReflectionReport()
            console.log('2 exportCSV')
            break
          case 3:
            break
          case 4:
            break
        }
      }
    },
    bindColumnsNameAndAlias: function () {
      this.columnNameToShow = []
      for (var i = 0; i < this.columnRespKey.length; i++) {
        var obj = {
          ColumnName: this.columnRespKey[i],
          ColumnAlias: this.columnAlias[i]
        }
        this.columnNameToShow.push(obj)
      }
    },
    getAssessmentMCQReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj.CohortId !== null && this.selectedCohortObj.CohortId !== undefined && this.selectedCohortObj.CohortId !== '') {
        this.$store.state.isLoading = true
        reportService.getAssessmentMCQReport(storeObj.state.access_token, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.currSelectedTabReportRespArr = responseObj.data
              if (parseInt(_this.currSelectedTabReportRespArr.length) === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No MCQ Assessment report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showAssessmentSubTypeReportList = false
              } else {
                this.checkAndProccessResp()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('COHORT ID is NULL hence declined LOADING ASSESSMENT MCQ REPORT LIST')
      }
    },
    getAssessmentReflectionReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj.CohortId !== null && this.selectedCohortObj.CohortId !== undefined && this.selectedCohortObj.CohortId !== '') {
        this.$store.state.isLoading = true
        reportService.getAssessmentReflectionReport(storeObj.state.access_token, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.currSelectedTabReportRespArr = responseObj.data
              if (parseInt(_this.currSelectedTabReportRespArr.length) === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No MCQ Reflection report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showAssessmentSubTypeReportList = false
              } else {
                this.checkAndProccessResp()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('COHORT ID is NULL hence declined LOADING ASSESSMENT REFLECTION REPORT LIST')
      }
    },
    convertToHoursMinsSeconds: function (durationInSeconds) {
      return moment().startOf('day').seconds(durationInSeconds).format('HH:mm:ss')
    },
    convertToHtmlForm: function (strToFormat) {
      const splitStr = strToFormat.split('||')
      var htmlToReturn = '<span>'
      for (var i = 0; i < splitStr.length; i++) {
        htmlToReturn += (i + 1) + '.' + splitStr[i] + '<br/>'
      }
      htmlToReturn += '</span>'
      return htmlToReturn
    },
    convertToPlainForm: function (strToFormat) {
      const splitStr = strToFormat.split('||')
      var htmlToReturn = ''
      for (var i = 0; i < splitStr.length; i++) {
        htmlToReturn += (i + 1) + '.' + splitStr[i] + '     '
      }
      htmlToReturn += ''
      return htmlToReturn
    },
    checkAndProccessResp: function () {
      switch (this.currentSelectedTab) {
        case 1:
          this.sortColumnNames = ['FirstName', 'LastName', 'Email', 'AssessmentTitle', 'AssessmentSubTitle', 'LessonTitle', 'QuestionTitle', 'QuestionText', 'UserAnswer', 'OptionText']
          this.columnRespKey = ['FirstName', 'LastName', 'Email', 'AssessmentTitle', 'AssessmentSubTitle', 'LessonTitle', 'QuestionTitle', 'QuestionText', 'UserAnswer', 'OptionText']
          this.columnRespKeyForExport = ['FirstName', 'LastName', 'Email', 'AssessmentTitle', 'AssessmentSubTitle', 'LessonTitle', 'QuestionTitle', 'QuestionText', 'UserAnswer', 'OptionText']
          this.columnAlias = ['First Name', 'Last Name', 'Email Id', 'Assessment Title', 'Assessment SubTitle', 'Lesson Title', 'Question Title', 'Question Text', 'Answer', 'Option Text']
          this.csvFileName = 'MCQAssessmentReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
          break
        case 2:
          this.sortColumnNames = ['FirstName', 'LastName', 'Email', 'Title', 'Content', 'UserAnswer', 'AssessmentTitle', 'AssessmentSubTitle']
          this.columnRespKey = ['FirstName', 'LastName', 'Email', 'Title', 'Content', 'UserAnswer', 'AssessmentTitle', 'AssessmentSubTitle']
          this.columnRespKeyForExport = ['FirstName', 'LastName', 'Email', 'Title', 'Content', 'UserAnswer', 'AssessmentTitle', 'AssessmentSubTitle']
          this.columnAlias = ['First Name', 'Last Name', 'Email Id', 'Title', 'Content', 'Answer', 'Assessment Title', 'Assessment SubTitle']
          this.csvFileName = 'ReflectionAssessmentReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
          break
        case 3:
          break
        case 4:
          break
      }
      this.bindColumnsNameAndAlias()
      if ((!this.isExportBtnClicked) && this.isViewBtnClicked) {
        // AK: If export btn not clicked and list is shown previously then show list only
        this.showAssessmentSubTypeReportList = true
      } else if (this.isExportBtnClicked && (!this.isViewBtnClicked)) {
        // AK: If user directly clicked on export button without clicking view first then export data
        this.exportData()
      } else if (this.isExportBtnClicked && this.isViewBtnClicked) {
        // AK: If user performed both operations then performed both operations
        this.showAssessmentSubTypeReportList = true
        this.exportData()
      }
    },
    exportData: function () {
      return csvHelper.export(this.getCurrSelectedTabReportRespArr, this.columnRespKeyForExport, this.columnAlias, this.csvFileName)
    }
  },
  computed: {
    getCurrSelectedTabReportRespArr: {
      get: function () {
        return this.currSelectedTabReportRespArr
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'assessment-sub-type-report'
}
</script>

<style scoped>
.assessment-sub-type-report {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.width {
  width: 100% !important;
}
.width1 {
  width: 97.3% !important;
}
.margin-left-0point2Perc {
  margin-left: 0.2% !important;
}
.margin-left-0point4Perc {
  margin-left: 0.4% !important;
}
.margin-left-1point6Perc {
  margin-left: 1.6% !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.font-size-20px
{
  font-size:20px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-Top-5Perc{
  margin-top: 5% !important;
}
.margin-left-1Perc{
  margin-left: 1% !important;
}
.padding-bottom-0Perc{
  padding-bottom: 0px; 
}
/* Using Only for footer */
.footer{
  /* position: fixed; */
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-left-2point6Perc {
  margin-left: 2.8% !important;
}
.width2 {
  width: 95.2% !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/AssessmentSubTypeReport.vue